export default {
  meta: {
    title: $localize`:@@meta.provably_fair.realization.title:Проверка честной игры → CSFAIL`,
    description: $localize`:@@meta.provably_fair.realization.description:С помощью удобного калькулятора можно проверить результат раунда любого игрового режима, вставив лишь номер игры!`
  }
};